import { Flex, IconButton, Text, DataItem } from '@cad-arc';
import { CorrectedLocation } from '../../../../../fr-entity-panels/types';
import { useViewLocationOnMap } from '../../../../../location/hooks/use-view-location-on-map';
import { isValidLatLng } from '../../../../../location/helpers';
import { CommonSize } from '../../../../../common/helpers/utils';

export function EntityLocation({
    dataKey,
    location,
    size,
    showViewOnMap = true,
}: {
    dataKey: string;
    location: CorrectedLocation;
    size?: CommonSize;
    showViewOnMap?: boolean;
}) {
    const viewLocationOnMap = useViewLocationOnMap();

    if (!location) {
        return null;
    }

    const handleViewEntityOnMap = () => {
        if (!isValidLatLng(location.latitude, location.longitude)) return;

        viewLocationOnMap({
            latitude: location.latitude as number,
            longitude: location.longitude as number,
            fullAddress: location.fullAddressKey,
            shouldMoveMapCenterToLoggedInUnit: false,
        });
    };

    return (
        <Flex
            width="100%"
            margin={0}
            padding={0}
            justifyContent="space-between"
            alignItems="center"
            gap="5px"
        >
            <Text fontSize={size}>
                <DataItem dataKey={dataKey}>
                    {`${location.displayLineFirst} ${location.displayLineLast}`}
                </DataItem>
            </Text>
            {showViewOnMap && (
                <IconButton
                    size={size}
                    variant="ghost"
                    icon="Crosshairs"
                    onClick={handleViewEntityOnMap}
                />
            )}
        </Flex>
    );
}
